<template>
    <div class="customer-sessions">
        <v-card>
            <v-card-title class="d-flex pt-1 pb-1" style="justify-content: space-between" >
                <TippTitle position="bottom" :tipp="about" title="Sessions" />
                <span style="flex: none !important; align-items: center" class="d-flex">
                    <SessionDeleteAllBtn />
                    <v-btn icon outlined small @click="loadSessions(ssoId)" :disabled="loading || deleting" :loading="loading">
                        <v-icon>mdi-cached</v-icon>
                    </v-btn>
                </span>
            </v-card-title>
            <v-card-text class="pt-0">
                <v-data-table
                    hide-default-footer
                    disable-pagination
                    :headers="headers"
                    :no-data-text="'Keine Sessions vorhanden.'"
                    :items="sessions"
                    :loading="loading"
                >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{ props.item.session_id }}</td>
                            <td>{{ props.item.tracking_id }}</td>
                            <td>{{ props.item.device_name_id }}</td>
                            <td>{{ props.item.services }}</td>
                            <td>{{ props.item.stores }}</td>
                            <td>{{ props.item.timestamp | toDatetime }}</td>
                            <td>
                                <SessionDeleteBtn :sessionId="props.item.session_id" />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions,
    mapMutations,
} from 'vuex';
import SessionDeleteBtn from '@/components/customer/SessionDeleteBtn.vue';
import SessionDeleteAllBtn from '@/components/customer/SessionDeleteAllBtn.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Sessions',
    props: ['ssoId'],
    components: {
        SessionDeleteBtn,
        SessionDeleteAllBtn,
        TippTitle,
    },
    data() {
        return {
            about: 'Zeigt Informationen zu gerade aktiven Anmeldungen (Sitzungen) des Benutzers an, welche Produkte er während dieser Session nutzt, aus welchem CeleraOne-Store sie stammen und ggf. welches Entgerät er dafür nutzt.',
            headers: [{
                text: 'Session ID',
                value: 'session_id',
                sortable: true,
                align: 'left',
            }, {
                text: 'Tracking ID',
                value: 'tracking_id',
                sortable: true,
                align: 'left',
            }, {
                text: 'Device Name / ID',
                value: 'device_name_id',
                sortable: true,
                align: 'left',
            }, {
                text: 'Services',
                value: 'services',
                sortable: true,
                align: 'left',
            }, {
                text: 'Stores',
                value: 'stores',
                sortable: true,
                align: 'left',
            }, {
                text: 'Datum',
                value: 'timestamp',
                sortable: true,
                align: 'left',
            }, {
                text: 'Beenden',
                value: 'session_id',
                sortable: false,
                align: 'left',
            }],
        };
    },
    computed: {
        ...mapState('customerSessions', [
            'loading',
            'deleting',
            'showDialog',
        ]),
        ...mapGetters('customerSessions', ['sessions']),
    },
    methods: {
        ...mapActions('customerSessions', [
            'deleteSession',
            'loadSessions',
        ]),
        ...mapMutations('customerSessions', [
            'hideDialog',
            'openDialog',
        ]),
        ...mapMutations('snackbar', ['success', 'error', 'info']),
    },
    mounted() {
        this.loadSessions(this.$props.ssoId);
    },
};
</script>

<style scoped lang="scss"></style>
